import {
  RawDestination,
  Destination,
  DestinationAction
} from '../interfaces/destination';
import { DestinationTypeFactory } from './destinationTypesFactory';
import { DESTINATION_STATUS_DATA_MAP } from '../constants/destinationStatus';
import { EntityMetaFactory } from '../../shared/factory/entityMetaFactory';
import { DESTINATION_ACTIONS_DISPLAY_DETAILS } from '../destination-actions/constant/destination-actions';
import { EntityActionsFactory } from '../../entity-actions/factories/entityActionsFactory';

export function DestinationListFactory(
  rawDestinations: RawDestination[],
  sort = true
): Destination[] {
  if (!rawDestinations) {
    return [];
  }

  const destinations = rawDestinations.map(DestinationFactory);

  if (!sort) {
    return destinations;
  }

  return destinations.sort((d1, d2) => d2.id - d1.id);
}

export function DestinationFactory(rawDestination: RawDestination): Destination {
  return {
    id: rawDestination.id,
    seqId: rawDestination.seq_id,
    name: rawDestination.name || '',
    destinationType: { ...DestinationTypeFactory(rawDestination.destination_type) },
    status: {
      ...DESTINATION_STATUS_DATA_MAP[rawDestination.status.type],
      helperText: rawDestination.status.hover_text
    },
    integrationsCount: rawDestination.integrations_count || 0,
    ...EntityMetaFactory({
      created_ts: rawDestination.created_ts,
      created_by: rawDestination.created_by,
      updated_by: rawDestination.updated_by,
      updated_ts: rawDestination.updated_ts
    }),
    actions: EntityActionsFactory<DestinationAction>(
      rawDestination.destination_actions ?? [],
      DESTINATION_ACTIONS_DISPLAY_DETAILS
    )
  };
}
